export default {
  navigation: {
    next: "Weiter",
    back: "Zurück",
    surveyNavigation: "Umfrage-Navigation",
    workspace: {
      home: "Startseite",
      example: "Beispiel"
    }
  }
}
